import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavala() {



    const cardData =
    {
        keyword: 'Pune to Lonavala Urbania On Rent',
        heading: 'Urbania on rent in pune: Pune to Lonavala Urbania On Rent',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Pune to Lonavala Urbania On Rent services for families, corporate groups, tourists, and event travelers planning trips to the scenic hill station of Lonavala. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for weekend getaways, corporate tours, sightseeing trips, and group travel from Pune to Lonavala. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free journey. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire from Pune to Lonavala.',

        top: 'Top Places to Visit in Lonavala with Urbania on rent in pune',


  "topPlaces": [
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is a popular monsoon destination in Lonavala, attracting tourists with its cascading water over stepped rocks and surrounding greenery. Visitors can enjoy picnics, water play, and photography while experiencing the serene ambiance of the Western Ghats. The area is lively during the rainy season, making it a favorite spot for families and friends."
  },
  {
    "title": "Lion’s Point",
    "description": "Lion’s Point offers breathtaking panoramic views of the Sahyadri mountains and the valley below. It is particularly famous for sunrise and sunset views, attracting photographers, nature lovers, and adventure enthusiasts. The viewpoint is accessible via short trekking paths and provides a peaceful environment to soak in the natural beauty."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic hill fort near Lonavala, popular for trekking and exploring Maratha-era architecture. The fort provides stunning views of the Kondana caves, surrounding valleys, and lush greenery. Adventure seekers enjoy the trek through forests, streams, and scenic landscapes, making it a perfect blend of history and nature."
  },
  {
    "title": "Karla Caves",
    "description": "Karla Caves are ancient Buddhist rock-cut caves dating back to the 2nd century BCE. The site features intricate chaitya halls, stupas, and sculptures that reflect early Indian architecture and Buddhist heritage. Visitors can explore the caves, learn about ancient Buddhist traditions, and enjoy the serene hilltop surroundings."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort is a historic fort situated atop a hill near Lonavala, known for its impressive fortifications, trekking trails, and panoramic views of the Western Ghats. The fort is especially popular during monsoon when the lush greenery and waterfalls enhance the scenic beauty. History enthusiasts and trekkers frequent the site for exploration and adventure."
  },
  {
    "title": "Tiger’s Leap",
    "description": "Tiger’s Leap is a cliff-top viewpoint resembling a leaping tiger, offering spectacular views of the valley, mountains, and waterfalls. It is ideal for photography, trekking, and observing the majestic Western Ghats. The viewpoint is especially enchanting during sunrise and monsoon, attracting nature lovers and adventure seekers."
  },
  {
    "title": "Kune Falls",
    "description": "Kune Falls is a picturesque three-tiered waterfall near Lonavala, surrounded by dense forests and hills. Visitors can enjoy trekking, photography, and picnicking near the falls. During the monsoon season, the waterfall is at its most spectacular, providing a serene and refreshing natural experience."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake is a man-made reservoir offering stunning views of the surrounding hills, especially during sunrise and sunset. Visitors can enjoy camping, boating, photography, and peaceful nature walks. The calm waters and scenic backdrop make it a favorite spot for relaxation and outdoor activities."
  },
  {
    "title": "Ryewood Park",
    "description": "Ryewood Park is a beautifully landscaped garden with walking paths, flowering plants, and shaded seating areas. Ideal for families, couples, and nature enthusiasts, the park provides a calm environment for leisurely strolls and photography while enjoying the greenery and natural beauty of Lonavala."
  },
  {
    "title": "Amrutanjan Point",
    "description": "Amrutanjan Point is a viewpoint near Lonavala known for its panoramic vistas of the surrounding valleys and hills. Visitors can relax, enjoy photography, and witness breathtaking sunsets. The location is perfect for a short stop while exploring the hill station and offers a serene escape amidst nature."
  }
],



"services": [
    {
      "name": "Pune to Lonavala Urbania on Rent",
      "description": "Pune to Lonavala Urbania on Rent provides comfortable and reliable vehicles for short and long-distance travel to the popular hill station of Lonavala. Perfect for families, groups, and corporate travelers, this service ensures spacious seating, professional chauffeurs, ample luggage space, and a smooth, stress-free journey while enjoying scenic views and a safe ride."
    },
    {
      "name": "Urbania Hire Pune to Lonavala",
      "description": "Urbania Hire Pune to Lonavala offers convenient and dependable vehicle rental options for intercity and hill station travel. Ideal for corporate trips, family outings, and group excursions, the service emphasizes punctual pickups, well-maintained vehicles, trained chauffeurs, and a comfortable, hassle-free journey to Lonavala."
    },
    {
      "name": "Urbania Bus Rental Pune to Lonavala",
      "description": "Urbania Bus Rental Pune to Lonavala provides spacious buses suitable for large groups, corporate tours, and family trips. Equipped with ample seating, safety features, and professional chauffeurs, these buses ensure an organized, comfortable, and enjoyable journey to Lonavala, making group travel convenient and stress-free."
    },
    {
      "name": "Urbania AC Bus Pune to Lonavala",
      "description": "Urbania AC Bus Pune to Lonavala offers fully air-conditioned buses for maximum comfort during travel to the hill station. Ideal for families, corporate groups, and tourists, these buses feature climate control, spacious seating, luggage space, and experienced drivers, ensuring a smooth and relaxing ride from Pune to Lonavala."
    },
    {
      "name": "Pune Lonavala Urbania One Way Hire",
      "description": "Pune Lonavala Urbania One Way Hire provides flexible travel options for individuals, families, and corporate groups. Vehicles are well-maintained, spacious, and driven by professional chauffeurs, offering a convenient, safe, and stress-free journey to Lonavala without worrying about return trips."
    },
    {
      "name": "Pune Lonavala Urbania Round Trip Hire",
      "description": "Pune Lonavala Urbania Round Trip Hire delivers reliable and comfortable round-trip transportation solutions. With clean vehicles, professional drivers, and timely service, travelers can enjoy a seamless journey to Lonavala and back to Pune, making it ideal for family outings, corporate trips, and group tours."
    },
    {
      "name": "Corporate Urbania Pune to Lonavala",
      "description": "Corporate Urbania Pune to Lonavala provides professional transportation for business trips, corporate retreats, and team outings. Vehicles offer executive comfort, spacious seating, and trained chauffeurs, ensuring a smooth, productive, and reliable travel experience for corporate teams traveling to Lonavala."
    },
    {
      "name": "Family Tour Urbania Pune to Lonavala",
      "description": "Family Tour Urbania Pune to Lonavala ensures safe, comfortable, and spacious vehicles for family vacations and group trips. With courteous chauffeurs, ample luggage space, and well-maintained interiors, families can enjoy a stress-free journey while exploring the natural beauty, attractions, and hill station charm of Lonavala."
    },
    {
      "name": "Luxury Urbania Pune to Lonavala",
      "description": "Luxury Urbania Pune to Lonavala provides high-end air-conditioned vehicles with plush interiors and superior ride quality for VIPs, executives, and travelers seeking premium comfort. Professional chauffeurs, smooth rides, and attention to detail guarantee a luxurious journey from Pune to the scenic hills of Lonavala."
    },
    {
      "name": "Affordable Urbania Pune to Lonavala",
      "description": "Affordable Urbania Pune to Lonavala delivers cost-effective transportation without compromising on comfort or reliability. Ideal for families, groups, and budget-conscious travelers, the service provides safe, clean vehicles and professional chauffeurs for a dependable and enjoyable journey to Lonavala."
    },
    {
      "name": "Chauffeur Driven Urbania Pune to Lonavala",
      "description": "Chauffeur Driven Urbania Pune to Lonavala offers stress-free travel with verified and experienced drivers. Vehicles are spacious, well-maintained, and suitable for long or short trips, allowing travelers to enjoy a safe, convenient, and comfortable ride from Pune to Lonavala without worrying about navigation or driving."
    },
    {
      "name": "Pune Lonavala Urbania Travel Service",
      "description": "Pune Lonavala Urbania Travel Service provides end-to-end transportation solutions for leisure, corporate, and group travel. With reliable vehicles, experienced chauffeurs, timely service, and luggage assistance, this service ensures a smooth, comfortable, and enjoyable journey to Lonavala for all types of travelers."
    },
    {
      "name": "Best Urbania Hire Pune to Lonavala",
      "description": "Best Urbania Hire Pune to Lonavala delivers top-rated intercity travel services with a focus on reliability, comfort, and customer satisfaction. Suitable for families, corporate teams, and group travelers, it ensures a smooth, safe, and timely journey from Pune to Lonavala, making it the preferred choice for hill station trips."
    },
    {
      "name": "Pune to Lonavala Urbania Booking",
      "description": "Pune to Lonavala Urbania Booking allows convenient reservation of Urbania vehicles for one-way or round-trip journeys. Travelers can select from multiple vehicle types to ensure a comfortable, safe, and hassle-free trip from Pune to Lonavala with professional chauffeur services included."
    },
    {
      "name": "Urbania Hill Station Trip Pune",
      "description": "Urbania Hill Station Trip Pune specializes in transportation for trips to hill stations like Lonavala. With comfortable vehicles, professional chauffeurs, and ample luggage space, the service ensures travelers can enjoy a scenic, safe, and relaxing journey while exploring the natural beauty and attractions of Lonavala."
    }
  ],
  "tableData": [
    ["Pune to Lonavala Urbania on Rent", "Urbania Hire Pune to Lonavala"],
    ["Urbania Bus Rental Pune to Lonavala", "Urbania AC Bus Pune to Lonavala"],
    ["Pune Lonavala Urbania One Way Hire", "Pune Lonavala Urbania Round Trip Hire"],
    ["Corporate Urbania Pune to Lonavala", "Family Tour Urbania Pune to Lonavala"],
    ["Luxury Urbania Pune to Lonavala", "Affordable Urbania Pune to Lonavala"],
    ["Chauffeur Driven Urbania Pune to Lonavala", "Pune Lonavala Urbania Travel Service"],
    ["Best Urbania Hire Pune to Lonavala", "Pune to Lonavala Urbania Booking"],
    ["Urbania Hill Station Trip Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Lonavala Urbania On Rent",
        "WhyChoosedescription": "Pune to Lonavala Urbania On Rent is perfect for comfortable and spacious group travel, ideal for family trips, corporate outings, weddings, and weekend getaways."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Pune to Lonavala Urbania On Rent provides well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and hassle-free journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Pune to Lonavala Urbania On Rent comes with skilled drivers familiar with Pune-Lonavala routes and highways, ensuring safe, timely, and stress-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Pune to Lonavala Urbania On Rent for competitive rates with no hidden charges, making short-distance group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Pune to Lonavala Urbania On Rent provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Pune to Lonavala Urbania On Rent is available for one-way trips, round trips, corporate travel, wedding transportation, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles for Pune to Lonavala trips are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Pune to Lonavala Urbania On Rent guarantees timely pickups and dependable service, ensuring stress-free and smooth travel."
    }
]
}

const faqData = [
    {
        question: 'Is Pune to Lonavala Urbania On Rent available for local travel as well?',
        answer: 'Yes, Pune to Lonavala Urbania On Rent can also be booked for local travel within Pune or nearby areas, offering a comfortable and spacious ride.',
    },
    {
        question: 'How can I book Pune to Lonavala Urbania On Rent?',
        answer: 'You can book Pune to Lonavala Urbania On Rent via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Pune to Lonavala Urbania On Rent for group travel?',
        answer: 'Pune to Lonavala Urbania On Rent provides ample seating, luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Pune to Lonavala Urbania On Rent suitable for corporate and event travel?',
        answer: 'Yes, it is perfect for corporate trips, airport transfers, weddings, events, and one-way or round-trip travel to Lonavala.',
    },
    {
        question: 'Are drivers experienced with Pune to Lonavala Urbania On Rent?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Pune to Lonavala Urbania On Rent?',
        answer: 'Absolutely. Pune to Lonavala Urbania On Rent allows flexible pickup and drop-off across Pune and Lonavala.',
    },
    {
        question: 'Is Pune to Lonavala Urbania On Rent available 24x7?',
        answer: 'Yes, Pune to Lonavala Urbania On Rent operates 24x7 to accommodate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Pune to Lonavala Urbania On Rent?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available for Pune to Lonavala Urbania On Rent?',
        answer: 'Pune to Lonavala Urbania On Rent accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sameer Joshi',
        feedback: 'We booked Pune to Lonavala Urbania On Rent for a weekend trip. The vehicle was spacious, clean, and comfortable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Patil',
        feedback: 'Pune to Lonavala Urbania On Rent provided a smooth and enjoyable ride for our corporate outing. The driver was professional and punctual. Highly recommended!',
        rating: 5,
    },
];































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Urbania On Rent",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-pune-to-lonavala.jpg",
  "description": "Pune to Lonavala Urbania On Rent offers AC and non-AC Urbania bus rental services for one-way and round-trip travel. Perfect for family tours, corporate trips, luxury travel, and hill station trips. Chauffeur-driven Urbania buses ensure comfortable, safe, and affordable journeys from Pune to Lonavala.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-lonavala-urbania-on-rent"
  }
};



    return (
        <div>
            
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Lonavala Urbania On Rent | AC & Luxury Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Pune to Lonavala Urbania On Rent for one-way or round-trip travel. AC and non-AC Urbania buses for family tours, corporate trips, luxury travel, and hill station trips. Chauffeur-driven service ensures safe and comfortable journeys."
  />

  <meta
    name="keywords"
    content="Pune to Lonavala Urbania on Rent, Urbania Hire Pune to Lonavala, Urbania Bus Rental Pune to Lonavala, Urbania AC Bus Pune to Lonavala, Pune Lonavala Urbania One Way Hire, Pune Lonavala Urbania Round Trip Hire, Corporate Urbania Pune to Lonavala, Family Tour Urbania Pune to Lonavala, Luxury Urbania Pune to Lonavala, Affordable Urbania Pune to Lonavala, Chauffeur Driven Urbania Pune to Lonavala, Pune Lonavala Urbania Travel Service, Best Urbania Hire Pune to Lonavala, Pune to Lonavala Urbania Booking, Urbania Hill Station Trip Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetolonavala;